'use client';

import dynamic from 'next/dynamic';
import React from 'react';
import { DesktopOnly } from './DesktopOnly';

const SmoothScroll = dynamic(
  () => import('./SmoothScroll').then((mod) => mod.SmoothScroll),
  {
    ssr: false,
  },
);

export const DesktopSmoothScrollLoader: React.FC = () => {
  return (
    <DesktopOnly minWidth={1024}>
      <SmoothScroll />
    </DesktopOnly>
  );
};
